import spinners from "../../loader/spinners"

export default{
    generateAccordion(acoordion_id){
        let html = "<div class='filter-container'></div><div id='"+acoordion_id+"' class='layer-control-component'></div>"
        return html
    },
    generateLayerCard(acoordion_id,layer, options = {loaded_layer: true, with_controls: true}){
        $("#"+acoordion_id).append(this.generateLayerCardStructure(layer,acoordion_id))
        $("#collapse_"+layer.id).find('.card-body').html(this.generateLayerCardBody(layer, options))
    },
    generateLayerCardBody(layer, opts){
        let html = ''

        if(opts.loaded_layer){//camada carregada com sucesso, informando no estilo do header
            this.updateLayerHeaderByState(layer.id, 0) 
        } else if(!opts.loaded_layer && layer.options.show) {//camada não carregada, mesmo usuário pedindo pra carregar
            //Adicionando linha de erro no card
            html += this.generateErrorLine(layer)
            //Informando erro no estilo do header.
            this.updateLayerHeaderByState(layer.id, 1)
        }
        
        html += "<div class='controls-container controls-container-"+layer.id+"'>"
        let controls_obj = [] //auxiliar apenas para um join com 'hr'
        $.each(layer.controls, (control, options)=>{
            let controls = {
                main: [],
                aditional: []
            }
            
            if(opts.with_controls && opts.loaded_layer){ //caso falso, não gera os controles auxiliares. Geralmente por que a camada não foi carregada corretamente anteriormente
                let c = "<div class='control p-3'>"   
                c += this.generateControlTitle(options.title)
            
                $.each(options, (option, value)=>{
                    if(value){
                        switch(option){
                            case 'color': 
                            controls.main[0] = this.generateColorControl(control,options, layer.id)
                                break;
                            case 'opacity':
                                controls.main[1] = this.generateOpacityControl(control, options,layer.id)       
                                break;
                            case 'width':
                                controls.aditional[0] = this.generateWidthControl(control, options,layer.id)       
                                break;
                        }
                    }
                })
                c += "<div class='main-options' style='display:flex;align-items:center'>"+controls.main.join("")+"</div>"
                c += "<div class='aditional-options'>"+controls.aditional.join("")+"</div>"
                c += '</div>'// control
                controls_obj.push(c)
            }
        })
        if(!layer.options.show && !opts.loaded_layer){
            html += "<div class='layer-description'>"+layer.description+"</div>"
        }
        if(!(layer.options.show && !opts.loaded_layer)){
            html += this.generateCheckboxControl(layer)
        }
        if(layer.feature_filter && layer.feature_filter.filterable && layer.featureGroup && opts.loaded_layer){
            html +=  "<div class='select-filter-features-container'></div>" //adicionando container que futuramente receberá o select
        }
        html += controls_obj.join("<hr>")
        html += '</div>'
        html += '</div>'
        return html
    },
    generateSelectFilter(layer,filter_options){
        let el = document.createElement('div')
        let html = "<select data-feature='"+layer.id+"' class='select-filter-features' multiple>"
        let currents = []
        if(filter_options.list && filter_options.list.length > 0){
            filter_options.list.forEach(item=>{
                html += "<option value='"+item.value+"' selected>" +item.text+ "</option>"
                currents.push(item.value)
            })
            
        } else {
            if(layer.featureGroup.type != "canvas"){
                layer.featureGroup.eachLayer(feature=>{
                    let value = _.get(feature.obj_prop,filter_options.field_value)
                    if(!filter_options.uniq || !currents.includes(value)){
                        html += "<option value='"+value+"' selected>" +_.get(feature.obj_prop,filter_options.field_name)+ "</option>"
                    }
                    currents.push(value)
                })
            } else {
                layer.featureGroup.markers.forEach(marker=>{
                    let value = _.get(marker.options.obj_prop,filter_options.field_value)
                    if(!filter_options.uniq || !currents.includes(value)){
                        html += "<option value='"+value+"' selected>" +_.get(marker.options.obj_prop,filter_options.field_name)+ "</option>"
                    }
                    currents.push(value)
                })
            }
        }
        
        
        html += "</select>"
        $(el).html(html)
        return $(el).find('select')
    },
    generateLayerCardStructure(layer,acoordion_id){
        let html = '<div class="mb-1 visible card layer-control-card layer-control-card-'+layer.id+'" data-layer="'+layer.id+'">'
        html += this.generateCardHeader(layer)
        html += '<div id="collapse_'+layer.id+'" class="collapse" aria-labelledby="headingOne" data-parent="#'+acoordion_id+'">'
        html += '<div class="card-body p-0"></div></div></div>';
        return html

    },
    generateControlTitle(control){
        return "<div class='control-title'>"+control+"</div>"
    },
    generateCardHeader(layer){
        return '<div class="card-header" id="headingOne" data-toggle="collapse" data-target="#collapse_'+layer.id+'" aria-expanded="true" aria-controls="collapseOne">'+
                '<h5 class="mb-0">'+layer.title+'</h5><div class="status"></div><i class="fas fa-chevron-up"></i>'+
                '</div>'
    },
    generateCheckboxControl(layer){
        let klass = (layer.options.show) ? 'btn-danger' : 'btn-success'
        let method = (layer.options.show) ? 'remove' : 'add'
        let title = (layer.options.show) ? 'Remover <i class="fas fa-times"></i>' : 'Adicionar <i class="fas fa-plus"></i>'
        return '<div class="form-group button-toggle-layer-container pb-0 pl-3 pt-1 pr-3 mb-1"></i>'+
                    '<button class="btn btn-block btn-sm '+klass+' button-toggle-layer" data-id="'+layer.id+'" data-method="'+method+'">'+title+'</button>'+
                '</div>'
    },
    generateColorControl(control, options,layer_id){
        return '<div style="flex:1"><div class="color-picker" data-color="'+options.dcolor+'" data-id="'+layer_id+'" data-type="'+this.toLeafletLanguage(control)[0]+'">'+
                '</div></div>'
    },
    generateOpacityControl(control, options,layer_id){
        return '<div class="form-group" style="flex:3">'+
                    '<label for="formControlRange">Opacidade</label>'+
                    '<input type="range" class="form-control-range range-picker-layer-options" data-id="'+layer_id+'" data-type="'+this.toLeafletLanguage(control)[1]+'" value="'+options.dopacity*100+'">'+
                '</div>'
    },
    generateFilter(options = {}){
        let html = '<div class="filter-box"><input type="text" class="form-control filter-box-input '+options.class+'" placeholder="'+ (options.placeholder || "Filtrar camadas...") +'"></input>'
        html += '<div class="floating-button">'
        html += (options.only_add) ? '<span class="mr-2 only_added_span badge">TODAS</span>' : ""
        html += (options.clear) ? '<span><i class="fas clear fa-times text-danger"></i></span>' : ""
        html += '</div></div>'
        return html
    },
    generateWidthControl(control, options,layer_id){
        return "<div class='form-group form-floating'><input type='number' data-type='weight' data-id='"+layer_id+"' placeholder='tamanho' class='form-control col-md-3 layer-control'></input><label>Tamanho</label></div>"
    },
    generateErrorLine(layer){
        return "<div class='load-layer-error'>Erro ao carregar a camada. <span class='text-primary reload-layer' data-id='"+layer.id+"'>Recarregar <i class='fas fa-redo-alt'></i></span></div>"
    },
    generateBodyLoadState(){
        return "<div class='spinner-container m-3'>"+spinners.sk_circle()+"</div>"
    },
    updateLayerHeaderByState(layer_id, status){
        //statuses = 0:succes, 1:fail, 2:default
        switch(status){
            case 0:
                $(".layer-control-card-"+layer_id).find('.card-header .status').html('<span class="badge badge-success badge-sm">Adicionada</span>')
                break;
            case 1:
                $(".layer-control-card-"+layer_id).find('.card-header .status').html('<span class="badge badge-danger badge-sm">Erro ao carregar camada</span>')
                break;
            case 2:
                $(".layer-control-card-"+layer_id).find('.card-header .status').html('')
                break;
        }
    },
    toLeafletLanguage(string){
        switch(string){
            case 'stroke':
                return ['color','opacity'];
                break;
            case 'fill':
                return ['fillColor', 'fillOpacity'];
                break
        }
    }
    
}